import React from 'react';
import { StatusTracker } from '../../../components';
import { useLoanStatusQuery } from '../../../hooks';
import StatusTrackerSkeleton from '../../../components/NewLoanInProgress/StatusTrackerSkeleton';
import { StatusUnderReview } from '../../../components/NewLoanInProgress/StatusUnderReview';
const StatusTrackerContainer = props => {
  return /*#__PURE__*/React.createElement(Container, props);
};
const Container = _ref => {
  let {
    url,
    accessToken,
    logApiEvent,
    loanNumber,
    isEnabled
  } = _ref;
  const {
    isSuccess,
    isInitialLoading,
    data
  } = useLoanStatusQuery({
    accessToken,
    url,
    logApiEvent,
    loanNumber,
    enabled: isEnabled
  });
  if (isInitialLoading) return /*#__PURE__*/React.createElement(StatusTrackerSkeleton, {
    dataTestID: 'loan-status-skeleton'
  });
  return isSuccess && data && isEnabled ? /*#__PURE__*/React.createElement(StatusTracker, {
    loanStatusData: data.responseDetails
  }) : /*#__PURE__*/React.createElement(StatusUnderReview, null);
};
export default /*#__PURE__*/React.memo(StatusTrackerContainer);
//# sourceMappingURL=index.js.map